import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "add-to-cart-panel__content" }
const _hoisted_3 = { class: "add-to-cart-panel__footer" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "add-to-cart-panel__col" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "add-to-cart-panel__col" }
const _hoisted_8 = { class: "add-to-cart-panel__tax" }
const _hoisted_9 = { class: "add-to-cart-panel__col" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "add-to-cart-panel__col" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "add-to-cart-panel__buttons" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]

import {onMounted, ref, computed, watch} from 'vue';
  import {useIsMobile} from '@/bps/utilities/composables/isMobile/isMobile';
  import basketStore from '../../../bps/stores/basket/BasketStore';
  import basketService from '../../../bps/services/basket/BasketService';
  import pigeon from '../../../bps/utilities/js/pigeon/pigeon';
  import jsGlobalConfig from '../../../bps/globals/jsGlobalConfig';
  import type BasketItem from '../../../bps/types/BasketItem';
  import SidePanel from '../../../bps/components/sidePanel/SidePanel.vue';
  import OrderPosition from '../../../bps/components/orderPosition/orderPosition.vue';
  import tracking from '@/bps/utilities/js/tracking/Tracking';
  import diContainer from '@/bps/utilities/js/diContainer/diContainer';
  import {t} from '@/bps/utilities/js/translations/translations';
  const freePrice = '0';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'addToCartPanel',
  props: {
    secondsToShow: { default: 5 },
    showTotalSavings: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const priceHelper = diContainer.get('priceHelper');

  const props = __props;

  onMounted(() => {
    pigeon.subscribe('productaddedToCart:updateCounter', () => {
      open(true);
    });
  });

  const {isMobile} = useIsMobile('tablet');

  let timeoutId = null;
  const basketUrl: string = jsGlobalConfig().getBasketUrl();
  const checkoutUrl: string = jsGlobalConfig().getCheckoutUrl();

  const isOpen = ref(false);
  const isLoading = ref(false);
  let tmpBasketItems = ref<BasketItem[]|null>(null);

  const basketItems = computed(() => {
    return tmpBasketItems.value || [...basketStore.items].reverse();
  });

  const summary = computed(() => {
    return basketStore.summary;
  });

  const totalSavings = computed(() => {
    return summary.value.totalSavings && props.showTotalSavings;
  });

  const isShippingFree = computed(() => {
    return priceHelper.isZero(summary.value.shipping);
  });

  const shippingCostText = computed(() => {
    return summary.value.shipping === freePrice ? t('checkout.basket.layer.freeShipping') : summary.value.shipping;
  });

  const notFreeShippingText = computed(() => {
    return basketStore.freeShippingFulFilled ? null : t('checkout.basket.deliveryCostsPromotion.upselling', [summary.value.leftUntilFreeShippingLimit]);
  })

  const minimumOrderText = computed(() => {
    // if already fulfilled or marketplace is active
    if (basketStore.minimumOrderValueFulFilled || jsGlobalConfig().getPartnerUrl()) {
      return null;
    }
    const minOrderLimit = summary.value.leftUntilMinOrderLimit;
    const noBottlesLimit = summary.value.leftUntilNoBottlesLimit;
    if ((minOrderLimit && minOrderLimit !== freePrice) && (noBottlesLimit && noBottlesLimit !== freePrice)) {
      if (summary.value.leftUntilNoBottlesLimit === '1') {
        return t('checkout.basket.minOrderLimit.one', [summary.value.leftUntilNoBottlesLimit, summary.value.leftUntilMinOrderLimit]);
      } else {
        return t('checkout.basket.minOrderLimit.other', [summary.value.leftUntilNoBottlesLimit, summary.value.leftUntilMinOrderLimit]);
      }
    }
    if (summary.value.leftUntilNoBottlesLimit === '1') {
      return t('checkout.basket.minOrderLimit.one', [summary.value.leftUntilNoBottlesLimit]);
    } else {
      const left = summary.value.leftUntilMinOrderLimit != null ? summary.value.leftUntilMinOrderLimit : summary.value.leftUntilNoBottlesLimit;
      return t('checkout.basket.minOrderLimit.other', [left]);
    }
  });

  // watch basketItems is length <= 0 then close the panel
  watch(basketItems, (newVal) => {
    if (newVal.length <= 0) {
      close();
    }
  });

  function open(withAddAnimation = false) {
    if (mayOpen() === false) {
      return;
    }

    clearCloseTimer();

    if (basketItems.value.length > 0) {
      setCloseTimer(props.secondsToShow * 1000);
      isOpen.value = true;
    }

    if (withAddAnimation) {
      tmpBasketItems.value = [...basketStore.items].reverse();
    }

    updateData().then(() => {
      if (basketStore.items.length === 0) {
        close();
        return;
      }
      else if (basketStore.items.length >= 2 && withAddAnimation) {
        tmpBasketItems.value = [...basketStore.items].reverse().slice(1);
      }

      if (location.href.indexOf(basketUrl) < 0) {
        setCloseTimer(props.secondsToShow * 1000);
        isOpen.value = true;
      }

      setTimeout(() => {
        tmpBasketItems.value = null;
      }, 50);

      // Make sure that the layer is open
      pigeon.publish('addToCartLayer:open');
    });

    pigeon.publish('addToCartLayer:open');
  }

  function close() {
    clearCloseTimer();
    isOpen.value = false;
    pigeon.publish('addToCartLayer:close');
  }

  function clearCloseTimer() {
    window.clearTimeout(timeoutId);
    timeoutId = null;
  }

  function setCloseTimer(time: number) {
    clearCloseTimer();
    timeoutId = setTimeout(close, time);
  }

  async function updateData(): Promise<any> {
    if (isLoading.value) {
      return new Promise(() => {
      });
    }

    isLoading.value = true;
    return basketService.loadMiniBasketData().then(() => {
      isLoading.value = false;
    })
  }

  function mayOpen(): boolean {
    const url = location.href;
    return url.indexOf(basketUrl) < 0 && url.indexOf(checkoutUrl) < 0 && url.indexOf('env=test') < 0;
  }

  function fireTracking() {
    tracking.fireCheckoutStep('checkout_step_1', 'mini-cart', basketStore.summary.grandTotalValue);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidePanel, {
    class: _normalizeClass(["side-panel--cart", {'side-panel--cart-mobile': _unref(isMobile)}]),
    "is-visible": isOpen.value,
    onCloseSidePanel: close,
    onClick: clearCloseTimer,
    onKeyup: _withKeys(clearCloseTimer, ["tab"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["add-to-cart-panel", {
        'add-to-cart-panel--with-total-savings': totalSavings.value,
        'add-to-cart-panel--not-free-shipping': !isShippingFree.value,
      }])
      }, [
        _createElementVNode("header", {
          class: "add-to-cart-panel__headline",
          "aria-label": _ctx.$t('addtocart.head')
        }, _toDisplayString(_ctx.$t('addtocart.head')), 9 /* TEXT, PROPS */, _hoisted_1),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _createElementVNode("section", _hoisted_2, [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "add-to-cart-panel__list-container",
                onScrollOnce: clearCloseTimer
              }, [
                _createVNode(_TransitionGroup, {
                  tag: "div",
                  name: "vue-animation--list",
                  class: "add-to-cart-panel__list",
                  role: "list",
                  "aria-label": _ctx.$t('checkout.ordersummary.basket.headline')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(basketItems.value, (item) => {
                      return (_openBlock(), _createBlock(OrderPosition, {
                        key: item.itemId,
                        item: item,
                        style: {'transition-duration': '.3s'},
                        class: "add-to-cart-panel__product",
                        "show-reduced": true,
                        "is-editable": !item.freeItem,
                        "disable-qty": "",
                        role: "listitem"
                      }, null, 8 /* PROPS */, ["item", "is-editable"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["aria-label"])
              ], 32 /* NEED_HYDRATION */))
            : _createCommentVNode("v-if", true),
          _cache[10] || (_cache[10] = _createTextVNode()),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", {
              class: "add-to-cart-panel__delivery add-to-cart-panel__cols",
              role: "row",
              "aria-label": _ctx.$t('checkout.basket.deliveryStatementText')
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('checkout.basket.deliveryStatementText')), 1 /* TEXT */),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createElementVNode("div", {
                class: _normalizeClass(["add-to-cart-panel__col", {'add-to-cart-panel__col--strong': summary.value.shipping === freePrice}])
              }, _toDisplayString(shippingCostText.value), 3 /* TEXT, CLASS */)
            ], 8 /* PROPS */, _hoisted_4),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("div", {
              class: "add-to-cart-panel__grand-total add-to-cart-panel__cols",
              role: "row",
              "aria-label": _ctx.$t('checkout.basket.invoiceDetails.totalAmount')
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t('checkout.basket.invoiceDetails.totalAmount')) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('checkout.basket.invoiceDetails.inclVAT')), 1 /* TEXT */)
              ]),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("div", _hoisted_9, _toDisplayString(summary.value.grandTotal), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_6),
            _cache[6] || (_cache[6] = _createTextVNode()),
            (totalSavings.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "add-to-cart-panel__total-savings add-to-cart-panel__cols",
                  role: "row",
                  "aria-label": _ctx.$t('checkout.basket.invoiceDetails.totalSavings')
                }, [
                  _createElementVNode("div", {
                    class: "add-to-cart-panel__col",
                    innerHTML: _ctx.$t('checkout.basket.invoiceDetails.totalSavings')
                  }, null, 8 /* PROPS */, _hoisted_11),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(summary.value.totalSavings), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_10))
              : _createCommentVNode("v-if", true),
            _cache[7] || (_cache[7] = _createTextVNode()),
            (minimumOrderText.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "add-to-cart-panel__upsell-promotion add-to-cart-panel__upsell-promotion--minimum-order",
                  innerHTML: minimumOrderText.value,
                  role: "alert"
                }, null, 8 /* PROPS */, _hoisted_13))
              : (notFreeShippingText.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "add-to-cart-panel__upsell-promotion add-to-cart-panel__upsell-promotion--not-free-shipping",
                    innerHTML: notFreeShippingText.value,
                    role: "alert"
                  }, null, 8 /* PROPS */, _hoisted_14))
                : _createCommentVNode("v-if", true)
          ]),
          _cache[11] || (_cache[11] = _createTextVNode()),
          _createElementVNode("section", _hoisted_15, [
            _createElementVNode("a", {
              class: "add-to-cart-panel__cart-btn | button button--secondary",
              href: _unref(basketUrl)
            }, _toDisplayString(_ctx.$t('addtocart.cartButton')), 9 /* TEXT, PROPS */, _hoisted_16),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createElementVNode("a", {
              class: "add-to-cart-panel__checkout-btn | button button--primary",
              href: _unref(checkoutUrl),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (fireTracking()))
            }, _toDisplayString(_ctx.$t('addtocart.checkoutButton')), 9 /* TEXT, PROPS */, _hoisted_17),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("div", {
              class: "add-to-cart-panel__close-link | button button--link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (close())),
              role: "button"
            }, _toDisplayString(_ctx.$t('addtocart.closeButton')), 1 /* TEXT */)
          ])
        ])
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "is-visible"]))
}
}

})